import { APP_BASE_HREF } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { FormDataService } from '@app/_core/services/form-data.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-select-agent',
  templateUrl: './select-agent.component.html',
  styleUrl: './select-agent.component.scss'
})
export class SelectAgentComponent implements OnInit,AfterViewInit {

  @Input()
  Heading: any;
  @Input()
  reason: any;
  @Input()
  notFound: any;
  showSearch: boolean;
  @Input() showAddUser: boolean;

  @Input()
  searchMemberObject: {};

  addMemberData = {
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    submitOptions:'callLater'
  };
  user: any;
  company: any;
  activityId: any;
  queueID: any;
  selectedUserID: any;
  addedUserID: any;
 
  constructor(
    private fb: FormBuilder,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private appService: AppService,
    private queueServices: QueuesService,
    private cdref: ChangeDetectorRef
  ) {}
  
  ngAfterViewInit(): void {
    console.log(this.addMemberData)
    console.log(this.reason)
  }

  async ngOnInit(): Promise<void> {
    this.Heading = 'Select Agent'
    this.notFound = 'add-find-member'
    console.log(this.showAddUser)
    console.log(this.addMemberData)
    console.log(this.searchMemberObject)
    // console.log(this.searchObject)
    this.showSearch = true;
    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.company = this.webStorageService.getItemFromSessionStorage('company');
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueID = queueId;
    });
  }

  
  handleSelectedUser(event) {
    console.log(event);
    if(event == 'not-found'){
      this.showAddUser = true;
      this.showSearch = false;
    }else{
      this.bsModalRef.content.onClose.next(event[0]);
      this.bsModalRef.hide();
    }
  }

  closeCaseCreation(){
    this.bsModalRef.hide();
  }


  cancel(){
    this.bsModalRef.hide();
  }
  confirm(){

    const data = {
      userData: this.addMemberData,
      activityID: this.activityId,
      queueID: this.queueID,
      userID: this.selectedUserID,
      company: this.company,
      user: this.user,
    };
    this.managerService.addNewUser(data).subscribe(res => {
console.log(res)
      // this.addedUserID = res.Response.Data
      const value =res.Response.Data.split('-');
      this.addedUserID = value[value.length - 1];
      console.log(this.addedUserID);
      if(res){
        this.managerService.getClientUser(this.addedUserID).subscribe(userData=>{
          console.log(userData);
          this.bsModalRef.content.onClose.next(userData.Response.Data);
          this.bsModalRef.hide();
      })

      }
     
        
      // https://tm.stage.cts-connect.com/services/Data/GetClientUser
      // userID: "155844"
    })
  }
}
